import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15.432c0 .928-.184 1.708-.552 2.34-.368.632-.856 1.14-1.464 1.524-.608.384-1.3.66-2.076.828-.7761.168-1.57204.252-2.38805.252h-6.768V3.38403h6.768c.65601 0 1.328.068 2.01605.204.688.136 1.3119.368 1.872.696.56.328 1.016.772 1.368 1.332.352.56001.528 1.272.528 2.136 0 .94401-.256 1.724-.768 2.33997-.512.616-1.184 1.06-2.016 1.332v.048c.48.08.932.228 1.356.444.424.216.792.492 1.104.828.312.336.56.728.744 1.176.184.448.276.952.276 1.512zm-4.656-7.12797c0-.576-.22-.996-.66005-1.26-.44-.264-1.09199-.396-1.956-.396h-2.016V10.152h2.208c.76801 0 1.364-.15597 1.788-.46797.42405-.312.63605-.77199.63605-1.38zm.552 6.74397c0-.704-.264-1.192-.792-1.464-.52805-.272-1.23204-.408-2.11205-.408h-2.28v3.888h2.304c.32 0 .652-.028.996-.084.344-.056.656-.156.936-.3.28005-.144.50805-.348.68405-.612.176-.264.264-.604.264-1.02zm7.32-.36V3.38403h4.032V14.688h-4.032zm4.368 3.648c0 .32-.06.62-.18.9s-.288.52-.504.72c-.216.2-.468.36-.756.48s-.592.18-.912.18c-.32 0-.62-.056-.9-.168-.28-.112-.524-.272-.732-.48-.208-.208-.376-.448-.504-.72-.128-.272-.192-.568-.192-.888 0-.304.06-.596.18-.876s.284-.524.492-.732c.208-.208.456-.372.744-.492s.592-.18.912-.18c.32 0 .624.06.912.18.288.12.54.28.756.48.216.2.384.44.504.72.12.28.18.572.18.876z",
    fill: "currentColor"
  }));
});